var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0.5C3.80603 0.5 0 4.30603 0 9C0 13.694 3.80603 17.5 8.5 17.5C13.194 17.5 17 13.694 17 9C17 4.30603 13.194 0.5 8.5 0.5ZM8.5 16.058C4.6029 16.058 1.44196 12.8971 1.44196 9C1.44196 5.1029 4.6029 1.94196 8.5 1.94196C12.3971 1.94196 15.558 5.1029 15.558 9C15.558 12.8971 12.3971 16.058 8.5 16.058Z",
    fill: "#959595"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8143 11.402L9.10876 9.44586V4.74999C9.10876 4.66651 9.04046 4.59821 8.95697 4.59821H8.04436C7.96088 4.59821 7.89258 4.66651 7.89258 4.74999V9.97521C7.89258 10.0245 7.91535 10.0701 7.95519 10.0985L11.0934 12.3867C11.1617 12.436 11.2565 12.4209 11.3059 12.3545L11.8485 11.6145C11.8978 11.5443 11.8826 11.4494 11.8143 11.402Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.3e509d1daf58ee6391198b338700963e.svg";
export { ForwardRef as ReactComponent };